import * as tslib_1 from "tslib";
import HeaderCharm from './HeaderCharm';
import { observer } from 'mobx-react';
import { TodoPane } from 'owa-header-pane';
import strings from 'owa-strings/owa-common-strings';
import * as React from 'react';
var TodoCharm = /** @class */ (function (_super) {
    tslib_1.__extends(TodoCharm, _super);
    function TodoCharm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TodoCharm.prototype.render = function () {
        return (React.createElement(HeaderCharm, { icons: { iconName: "ToDoLogoOutline" /* ToDoLogoOutline */ }, ariaLabel: strings.todoCharm_ariaLabel, title: strings.todoCharm_ariaLabel, behavior: {
                paneComponent: TodoPane,
                charm: 9 /* TodoCharm */,
            } }));
    };
    TodoCharm = tslib_1.__decorate([
        observer
    ], TodoCharm);
    return TodoCharm;
}(React.Component));
export default TodoCharm;
//# sourceMappingURL=TodoCharm.js.map